import { render, staticRenderFns } from "./ReferralFooter.vue?vue&type=template&id=05caa406"
import script from "./ReferralFooter.vue?vue&type=script&lang=js"
export * from "./ReferralFooter.vue?vue&type=script&lang=js"
import style0 from "./ReferralFooter.vue?vue&type=style&index=0&id=05caa406&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports